import "./App.css";
import * as React from "react";
import Login from "./pages/Login";
import CreateNewAccount from "./pages/CreateNewAccount";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { QueryClient, QueryClientProvider } from "react-query";
import { AlertProvider } from "./contexts/AlertProvider";
import { UserProvider } from "./contexts/UserProvider";
import { ToolBarProvider } from "./contexts/ToolBarProvider";
import AlertBar from "./components/AlertBar";
import LoadingIndicator from "./components/LoadingIndicator";
import VerfiyEmail from "./components/User/VerifyEmail";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
  Outlet,
} from "react-router-dom";
import { useUser } from "./contexts/UserProvider";

const ClientDashboardPage = React.lazy(() => import("./pages/ClientDashboardPage"));
const AgentViewContainer = React.lazy(() => import("./components/Agent/AgentViewContainer"));
const GroupViewContainer = React.lazy(() => import("./components/Group/GroupViewContainer"));
const TutorialViewContainer = React.lazy(() => import("./components/TutorialViewContainer"));
const SettingsViewContainer = React.lazy(() => import("./components/Settings/SettingsViewContainer"));

// Set up React Query client
const queryClient = new QueryClient();

// Sends visitors without a session back to the login page.
function RequireAuth() {
  const { token } = useUser();
  if (!token) return <Navigate to="/" replace />;

  return (
    <React.Suspense fallback={<LoadingIndicator />}>
      <Outlet />
    </React.Suspense>
  );
}

// Define the routes using createBrowserRouter
const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/createNewAccount/*",
    element: <CreateNewAccount />,
  },
  {
    path: "/verifyEmail",
    element: <VerfiyEmail />,
  },
  {
    path: "/resetPassword/*",
    element: <ResetPassword />,
  },
  {
    element: <RequireAuth />,
    children: [
      {
        path: "/clientDashboard/*",
        element: <ClientDashboardPage />,
      },
      {
        path: "/adminTable/*",
        element: <AgentViewContainer />,
      },
      {
        path: "/groupDashboard/*",
        element: <GroupViewContainer />,
      },
      {
        path: "/tutorials",
        element: <TutorialViewContainer />,
      },
      {
        path: "/settings",
        element: <SettingsViewContainer />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <AlertProvider>
          <UserProvider>
            <ToolBarProvider>
              <AlertBar />
              <RouterProvider router={router} />
            </ToolBarProvider>
          </UserProvider>
        </AlertProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
